<template>
<div>
   <v-card-title class="search-box-card">
      <v-text-field
        class="search-box"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        color="#c2d5d8"
      ></v-text-field>
    </v-card-title>
  <div class="leaderboard">
    <v-data-table
        :headers="headers"
        :items="leaderboardData"
        :search="search"
        :rows-per-page-items="[10]"
        :rows-per-page-text="null"
        must-sort
        class="table-container"
    >
        <template slot="items" slot-scope="props"> 
            <tr class="leaderboard-row" :data-userHash="props.item.userHash" @click="onClickRow">
                <td class="text-xs-left body-2"> {{props.item.rank}} </td>
                <td class="text-xs-left body-2 name-column"> <div class="user-avatar body-2" v-html="props.item.avatar"></div><div class="username"> {{props.item.username}}</div> </td>
                <td class="text-xs-right body-2">${{ props.item.cash.toLocaleString() }}</td>
                <td class="text-xs-right body-2">{{ props.item.dealsMade }} </td>
                <td class="text-xs-right body-2">{{ props.item.achievementCount }}</td>
            </tr>
        </template>
         <v-alert class="bad-search" slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
         </v-alert>
    </v-data-table>
  </div>

  </div>
</template>

<script>
import Avatars from "@dicebear/avatars";
import SpriteCollection from "@dicebear/avatars-identicon-sprites";
import axios from 'axios';

function getAvatar(hash) { 
    let avatars = new Avatars(SpriteCollection);
    return avatars.create(hash);
}

export default {
  name: 'Profile',
  props: ["id"],
  data: () => { 
    return {
      search: '',
      leaderboardData: [
      ],
      headers: [{ text: "Rank", value: "rank", align: "left" },
                { text: "Name", value: "username", align: "left" },
                { text: "Net Worth", value: "cash", align: "right"},
                { text: "Deals", value: "dealsMade", align: "right"},
                { text: "Achievements", value: "achievementCount", align: "right"}
            ]
    }
  },
  mounted() {
    axios.get("https://7vrdif15wa.execute-api.us-east-1.amazonaws.com/dev/getleaderboard").then(response => {
        this.leaderboardData = response.data.leaderboard.map((entry) => {
            entry.avatar = getAvatar(entry.userHash);
            if(!entry.username) {
                entry.username = "Anonymous";
            }
            return entry;
        });
    });
  },
  methods: {
      onClickRow: function(e) {
          const userHash = e.currentTarget.dataset.userhash
          this.$router.push({ path: `/profile/${userHash}` })
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
th {
    padding: 0 5px !important;
}
</style>

<style scoped>
.leaderboard {
    display: flex;
    text-align: center;
    justify-content: space-between;
    width: unset;
    /*height: 70vh;*/
    margin: 10px;
    padding: 20px;
    border: 2px solid #c2d5d8;
    border-radius: 5px;
    background: white;
    background: rgba(255,255,255,.9) 
}
.leaderboard-row {
    margin-bottom: 5px;
}
.search-box-card {
    padding: 10px;
}
.search-box {
    border: 2px solid #c2d5d8;
    padding: 0px 10px;
    border-radius: 5px;
    background: rgba(255,255,255,.9);
}
.user-avatar {
    width: 30px;
    height: 30px;
    margin-left: -10px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
}
.username {
    display: inline-block;
}
.name-column {
    white-space: nowrap;
}
.table-container {
    width: 100%;
}
.table-container v-table__overflow {
    overflow: scroll;
}

</style>
<style>
    .table-container .v-table tbody td:first-child, .table-container .v-table tbody td:not(:first-child), .table-container .v-table tbody th:first-child, .table-container .v-table tbody th:not(:first-child), .table-container .v-table thead td:first-child, .table-container .v-table thead td:not(:first-child), .table-container .v-table thead th:first-child, .table-container .v-table thead th:not(:first-child) {
        padding: 0px 5px;
    }
    .v-text-field .v-input__slot:after, .v-text-field .v-input__slot:before {
        display: none;
    }
</style>